import { ofType } from "redux-observable";
import { mergeMap } from "rxjs/operators";

import "isomorphic-fetch";
import { polyfill } from "es6-promise";
import {
  OFLC_SEND_INVITATION,
  sendInvitationSuccess,
  sendInvitationFail,
} from "../actions/action_sendInvitation";
import util from "../../../global/utils/Helpers";
polyfill();

let apiIndex = util.isLocalhost()
  ? "http://localhost:9393/auth/graphql"
  : `${util.getCurrentHost()}/auth/auth/graphql`;

const getQuery = (userEmail) => {
  // let state = store.getState();
  // let currtUser = state.appReducer.userDataReducer.data;
  let x = JSON.stringify({
    query: `
			mutation {
			createInvitation(
			  email: "${userEmail}"
			)
		  }`,
  });
  return x;
};

const sendInvitationEpic = (action$) =>
  action$.pipe(
    ofType(OFLC_SEND_INVITATION),
    mergeMap((action) =>
      fetch(apiIndex, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: getQuery(action.payload),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.errors) {
            return sendInvitationFail(data.errors);
          } else {
            return sendInvitationSuccess(data);
          }
        })
        .catch((error) => {
          return sendInvitationFail(error);
        })
    )
  );

export default sendInvitationEpic;
